import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {AuthService} from '../auth/auth.service';

@Injectable()
export class PlacesService {

  private selectPlaceManager: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public selectPlace: Observable<any>;

  constructor(private authService: AuthService) {
    this.selectPlace = this.selectPlaceManager.asObservable();

    this.authService.logOut.subscribe((doLogout) => {
      if (doLogout) {
        this.selectPlaceManager.next(null);
      }
    });
  }

  select(placeId) {
    this.selectPlaceManager.next(placeId);
  }

}



// WEBPACK FOOTER //
// ./client/app/core/places/places.service.ts